export default {
    'BILLFISH FIM INVESTIMENTO NO E': '19.366.027/0001-20',
    'LEBLON 100 ICATU PREV FIM': '35.314.803/0001-03',
    'LEBLON 100 XP SEGUROS PREV FI': '34.462.068/0001-04',
    'LEBLON 70 XP SEGUROS PREV FIM': '27.793.095/0001-02',
    'LEBLON ACOES FIC DE FIA': '10.320.151/0001-80',
    'LEBLON ACOES II FIC DE FIA': '26.768.800/0001-40',
    'LEBLON EQUITIES PARTNERS FIM I': '10.309.567/0001-06',
    'LEBLON EQUITIES PARTNERS II FI': '09.172.710/0001-73',
    'LEBLON EQUITIES PARTNERS VII F': '18.448.173/0001-32',
    'LEBLON ICATU PREVIDENCIA FIM': '11.098.129/0001-09'
}